var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3 index-app"},[(
      Object.entries(_vm.configObject).length > 0 &&
      _vm.isAdvanced === false &&
      _vm.isGIS === false &&
      _vm.loading === false
    )?_c('MSDAT'):_vm._e(),(_vm.$route.query.prev)?_c('div',{staticClass:"preview"},[_c('b-button',{staticStyle:{"font-size":"1.5rem"},attrs:{"size":"lg","variant":"info"},on:{"click":function($event){return _vm.$router.push('/custom/requests')}}},[_vm._v("Back to Requests")])],1):_vm._e(),_c('NewsLetter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }